import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const NavBar = () => {
  const navRef = useRef(null);

  useEffect(() => {
    const navElement = navRef.current;

    gsap.to(navElement.childNodes, {
      translateY: '200px',
      delay: 3.5,
      stagger: -0.3,
    });

    const tlColorChange = gsap.timeline();
    tlColorChange.set('#nav', {
      color: 'black',
    });
    tlColorChange.to('#nav', {
      color: 'white',
      textShadow: '1px 1px #000',
      backgroundColor: 'black',
    });

    ScrollTrigger.create({
      trigger: '#skills',
      start: 'top 10%',
      end: 'bottom bottom',
      scrub: true,
      animation: tlColorChange,
    });
  }, []);

  return (
    <div className="nav-cont">
      <div ref={navRef} id="nav">
        <a className="nav-button" href="#skills-content">
          About me
        </a>
        <a className="nav-button" href="#projects">
          Projects
        </a>
        <a className="nav-button" href="#contact">
          Contact
        </a>
      </div>
    </div>
  );
};

export default NavBar;
